import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M20.031 2H4C2.895 2 2 2.895 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V3.969C22 3.062 20.895 2 20.031 2V2ZM17.088 9.391L17.096 9.731C17.096 13.199 14.455 17.199 9.627 17.199C8.143 17.199 6.764 16.766 5.6 16.02C5.807 16.043 6.014 16.055 6.225 16.055C7.455 16.055 8.588 15.637 9.487 14.934C8.337 14.91 7.37 14.153 7.034 13.11C7.198 13.141 7.362 13.156 7.53 13.156C7.768 13.156 8.002 13.125 8.221 13.067C7.022 12.824 6.116 11.762 6.116 10.489V10.457C6.47 10.653 6.872 10.774 7.302 10.785C6.599 10.317 6.134 9.512 6.134 8.602C6.134 8.121 6.263 7.668 6.49 7.281C7.787 8.871 9.72 9.914 11.904 10.024C11.862 9.832 11.838 9.633 11.838 9.426C11.838 7.977 13.014 6.801 14.463 6.801C15.217 6.801 15.901 7.121 16.377 7.629C16.979 7.512 17.541 7.293 18.049 6.992C17.85 7.606 17.436 8.121 16.893 8.446C17.424 8.383 17.932 8.239 18.401 8.031C18.049 8.559 17.603 9.02 17.088 9.391V9.391Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'TwitterFill');

export default Icon;
